import CommentInput from '../../../../components/CommentInput';
export default function InputComment(props) {
  const { current_user, setContent, content, submitReplyComment, typeInput, comment } = props;
  return (
    <div className="box-child-cmt">
      <img
        className="bg-img-orgnal avtar40 position-absolute img-cmt-box"
        style={{ paddingTop: '0', width: '40px', height: '40px', left: '0' }}
        src={current_user?.image ?? '/images/avatar.png'}
        alt=""
      />

      <CommentInput
        component="div"
        onChange={setContent}
        content={typeInput === 'reply' ? content : typeInput === 'edit' ? comment.content : ''}
        placeholder={'Nhập nội dung'}
        typeInput={typeInput}
      />

      <div className="d-flex justify-content-end mt-2">
        <div
          className="position-absolute btn-send-cmt"
          style={{
            backgroundImage: 'url("/images/send-message.png")',
            width: '23px',
            height: '23px',
            right: '10px',
          }}
          onClick={() => submitReplyComment(comment.id, content, typeInput)}
        ></div>
      </div>
    </div>
  );
}
